import React from 'react';
import { Formik, Form } from 'formik';
import { Button } from '../Button/Button';
import { FormFields } from './FormFields';
import { AddUserFormValues, validationSchema } from './types';
import { useEditUserForm } from './hooks/useEditUserForm';
import './UserForm.scss';

interface EditUserFormProps {
  userId: number;
  onSubmit: (values: AddUserFormValues) => void;
  onCancel: () => void;
}

export const EditUserForm: React.FC<EditUserFormProps> = ({ userId, onSubmit, onCancel }) => {
  const { handleSubmit, getInitialValues, userDetails } = useEditUserForm({
    userId,
    onSubmit,
    onCancel,
  });

  return (
    <div className="user-form">
      <h2>Edit User</h2>
      <Formik
        initialValues={getInitialValues()}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => (
          <Form onSubmit={formik.handleSubmit}>
            <FormFields formik={formik} userDetails={userDetails} />
            <div className="form-actions">
              <Button variant="button" className="outline cancel" type="button" onClick={onCancel}>
                Cancel
              </Button>
              <Button variant="button" type="submit">
                Save Changes
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};
